var map = {
	"./2.png": 282,
	"./3.png": 284,
	"./4.png": 286,
	"./5.png": 288,
	"./v2/2.png": 167,
	"./v2/3.png": 168,
	"./v2/4.png": 169,
	"./v2/5.png": 170,
	"./v2/border-jackpot.png": 114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99;